require('angular')
require('angular-route')
require('angular-ui-map')

require('../../core/translation/translation-module')
require('../components/flash/flash-module')
require('../components/error-handler/error-handler-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/form/form-module')
require('../components/animate/animate-module')
require('../components/account/account-module')
require('../components/auth/auth-module')
require('../group-event/group-event-module')


#load Templates
require('./index.jade')

# Load Css
require('../../../sass/web/html/_group_timeline.scss')

GroupTimelineCtrl = require('./group-timeline-controller')
GroupTimelineService = require('./group-timeline-service')
TimelineCreateEventDirective = require('./timeline-create-event-directive/timeline-create-event-directive')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-common-wrapper'
  'gnp-remote-api'
  'gnp-form'
  'gnp-flash'
  'gnp-animate'
  'gnp-error-handler'
  'gnp-app-group-event'
]

angular.module 'gnp-app-group-timeline', modules
  .config ['$routeProvider', '$translateProvider', ($routeProvider, $translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .factory 'GroupTimelineService', GroupTimelineService
  .controller 'GroupTimelineCtrl', GroupTimelineCtrl
  .directive 'timelineCreateEvent', TimelineCreateEventDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-timeline/group-timeline-module.coffee